import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../assets/images/hero-image.png';
import './Hero.css';

const Hero = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = heroImage;
    img.onload = () => {
      setImageLoaded(true);
    };
  }, []);

  return (
    <section 
      className={`hero ${imageLoaded ? 'hero-loaded' : ''}`}
      style={{ backgroundImage: imageLoaded ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${heroImage})` : 'none' }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="hero-title">Apprenez à conduire en toute confiance</h1>
          <p className="hero-subtitle">Votre réussite, notre priorité.</p>
          <div className="hero-buttons">
            <Link to="/formations" className="btn btn-orange">
              Nos Formations
            </Link>
            <Link to="/contact" className="btn btn-white">
              Contactez-Nous
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
